import script from "./sponsorships.vue?vue&type=script&setup=true&lang=js"
export * from "./sponsorships.vue?vue&type=script&setup=true&lang=js"

import "./sponsorships.vue?vue&type=style&index=0&id=09b6549a&lang=scss&scoped=true"
script.__scopeId = "data-v-09b6549a"

export default script